import { forwardRef } from "react";

import Icon from "@/components/Icon";
import RawFormativeIcon from "./RawFormativeIcon.svg.jsx";

const FormativeIcon = forwardRef((props, ref) => {
  return <Icon ref={ref} SvgComponent={RawFormativeIcon} {...props} />;
});

export default FormativeIcon;
